import styled from "@emotion/styled";

import { MergeWithOverwrite } from "src/common";
import { colors } from "src/theme";

const IconSpan = styled.span((props: { height: number, width: number }) => ({
  display: 'inline-flex',
  height: props.height,
  width: props.width,
}))

export type DownloadIconProps = MergeWithOverwrite<React.HtmlHTMLAttributes<HTMLSpanElement>, {
  width?: number,
  height?: number,
  color?: string,
}>;

export const DownloadIcon: React.FC<DownloadIconProps> = ({ width = 16, height = 16, color = colors.primary, ...props }) => (
  <IconSpan {...props} width={width} height={height}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_2359_86440)">
        <path d="M12 12H0V11H12V12ZM6.5 8.29297L10 4.79297L10.707 5.5L6 10.207L1.29297 5.5L2 4.79297L5.5 8.29297V0H6.5V8.29297Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_2359_86440">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  </IconSpan>
)